import { Certificate } from '../../models/interfaces/certificate.interface';

const USER_ID = '1c41afca-e637-4d9f-8cd1-2b3f3302f80d';
const TENANT_ID = 'tenant-uuid-1';
const DATE_2026_01_30 = new Date('2026-01-30');
const DATE_2025_11_10 = new Date('2025-11-10');

/**
 * Certificados usados apenas pelo fake backend e pelos testes.
 */
export const certificateMock: Certificate[] = [
  {
    id: '5f0c1c2e-4b8a-4e0e-9c55-2a1f6c3d7b01',
    tenantId: TENANT_ID,
    userId: USER_ID,
    courseId: 'course-uuid-3',
    courseTitle: 'Node.js para Web',
    courseDurationMinutes: 600,
    completedAt: DATE_2026_01_30,
    createdAt: DATE_2026_01_30,
    updatedAt: DATE_2026_01_30,
    isActive: true,
  },
  {
    id: '9a7d3e44-1f2b-4c6d-8e90-3b5a7c9d1e02',
    tenantId: TENANT_ID,
    userId: USER_ID,
    courseId: 'course-uuid-removed',
    courseTitle: 'Curso descontinuado de Git',
    courseDurationMinutes: null,
    completedAt: DATE_2025_11_10,
    createdAt: DATE_2025_11_10,
    updatedAt: DATE_2025_11_10,
    isActive: true,
  },
];
